import Message from "../../Message";
import Modal from "../Modal";
import { postJson } from "../../utils";
import {
  getStripeElementsAppearance,
  getStripePaymentElementOptions,
} from "../Checkout/checkout-utils";

const initBookNowPayLaterPaymentMethodUpdate = () => {
  const root = document.getElementById('bnpl-payment-method-update');
  if (!root) {
    return;
  }

  const openAddPaymentMethodButtons = document.querySelectorAll('[data-bnpl-open-add-payment-method]');
  const confirmPaymentMethodButton = root.querySelector('[data-bnpl-confirm-payment-method]');
  const paymentElementContainer = document.getElementById('bnpl-payment-method-update-element');
  let stripe = null;
  let elements = null;
  let setupIntent = null;
  let paymentElement = null;
  let setupIntentLoading = false;

  const removeStripeQueryParams = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete('setup_intent');
    url.searchParams.delete('setup_intent_client_secret');
    url.searchParams.delete('redirect_status');
    window.history.replaceState({}, document.title, url.toString());
  };

  const finalizeReturnedSetupIntent = async () => {
    const url = new URL(window.location.href);
    const setupIntentId = url.searchParams.get('setup_intent');
    if (!setupIntentId || !root.dataset.confirmUrl) {
      return;
    }

    try {
      const formData = new FormData();
      formData.append('setup_intent', setupIntentId);

      const data = await postJson(root.dataset.confirmUrl, formData);

      window.location.href = data.redirectUrl || root.dataset.returnUrl;
    } catch (error) {
      removeStripeQueryParams();
      Message.error(error.message);
      await openAddPaymentMethodModal();
    }
  };

  const createSetupIntent = async () => {
    if (setupIntent) {
      return setupIntent;
    }

    if (setupIntentLoading || !root.dataset.createSetupIntentUrl) {
      return null;
    }

    setupIntentLoading = true;

    try {
      const data = await postJson(root.dataset.createSetupIntentUrl);
      setupIntent = data.setupIntentPayload;
      return setupIntent;
    } catch (error) {
      Message.error(error.message);
      return null;
    } finally {
      setupIntentLoading = false;
    }
  };

  const getBillingDetails = () => ({
    name: root.dataset.billingName || '',
    email: root.dataset.billingEmail || '',
    phone: root.dataset.billingPhone || '',
  });

  const mountPaymentElement = async () => {
    if (elements && paymentElement) {
      return true;
    }

    const setupIntentPayload = await createSetupIntent();
    if (!setupIntentPayload || !paymentElementContainer) {
      return false;
    }

    if (!stripe) {
      stripe = Stripe(root.dataset.stripePublishKey);
    }

    elements = stripe.elements({
      clientSecret: setupIntentPayload.client_secret,
      appearance: getStripeElementsAppearance(),
    });

    paymentElement = elements.create('payment', getStripePaymentElementOptions());
    paymentElement.mount('#bnpl-payment-method-update-element');

    return true;
  };

  const openAddPaymentMethodModal = async () => {
    Modal.closeModal('#bnplPaymentFailedModal');
    Modal.openModal('#bnplAddPaymentMethodModal');
    await mountPaymentElement();
  };

  openAddPaymentMethodButtons.forEach(button => {
    button.addEventListener('click', openAddPaymentMethodModal);
  });

  if (confirmPaymentMethodButton) {
    confirmPaymentMethodButton.addEventListener('click', async () => {
      const isReady = await mountPaymentElement();
      if (!isReady || !stripe || !elements) {
        return;
      }

      confirmPaymentMethodButton.disabled = true;
      confirmPaymentMethodButton.classList.add('loading');

      const result = await stripe.confirmSetup({
        elements,
        confirmParams: {
          return_url: root.dataset.returnUrl,
          payment_method_data: {
            billing_details: getBillingDetails(),
          },
        },
      });

      if (result.error) {
        confirmPaymentMethodButton.disabled = false;
        confirmPaymentMethodButton.classList.remove('loading');
        Message.error(result.error.message);
      }
    });
  }

  finalizeReturnedSetupIntent();

  if (root.dataset.openFailed === '1') {
    Modal.openModal('#bnplPaymentFailedModal');
  } else if (root.dataset.openAddPaymentMethod === '1') {
    openAddPaymentMethodModal();
  }

  if (root.dataset.paymentMethodUpdated === '1') {
    Message.success(root.dataset.paymentMethodUpdatedMessage);
  }
};

export { initBookNowPayLaterPaymentMethodUpdate };
